
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from "./serviceWorker";

// Wait for DOM to be ready before trying to mount React
const initApp = () => {
  const container = document.getElementById('bl-idg-root');

  // Only create root if container exists on this page
  if (!container) {
    return;
  }

  const root = createRoot(container);

  root.render(<App />);
};

// Check if DOM is already loaded
if (document.readyState === 'loading') {
  // Still loading, wait for DOMContentLoaded event
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  // DOM is already ready, initialize immediately
  initApp();
}

serviceWorker.unregister();
